/*
 *  File: app-routing.module.ts
 ********************************************************************
 *  Date        Author                 Changes
 ********************************************************************
 *  02/01/18    Dhanalakshmi Lolugu    Created
 ********************************************************************
 * Copyright (c) 2009 Synapse Group, Inc.
 * 225 High Ridge Park, Stamford, Connecticut, 06905-1325, U.S.A.
 * All rights reserved.
 *
 * This software is the confidential and proprietary information of
 * Synapse Group, Inc. ("Confidential Information"). You shall not
 * disclose such Confidential Information and shall use it only in
 * accordance with the terms of the license agreement you entered
 * into with Synapse Group, Inc.
 */

import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SearchComponent } from './search/search.component';
import { CancelComponent } from './cancel/cancel.component';
import { ConfirmComponent } from './confirm/confirm.component';
import { ErrorComponent } from './error/error.component';
import { CustomerServiceComponent } from './customer-service/customer-service.component';

const routes: Routes = [
  //Search Page
  {
    path: 'search',
    component: SearchComponent,
  },
  //Cancel Page with cancel and customer service
  {
    path: 'cancel-item',
    component: CancelComponent,
  },
  //Confirmation page for cancel and customer service
  {
    path:'cancel-confirm',
    component: ConfirmComponent
  },
  //Any errors with Oops page
  {
    path: 'error',
    component: ErrorComponent
  },
  //Customer service page
  {
    path: 'customer-service',
    component: CustomerServiceComponent
  },
  //Home page without any specific routers
  {
    path: '',
    redirectTo: '/search',
    pathMatch: 'full'
  },
  //Above all roters are not matched, when page not found
  { 
    path: '**',
    component: ErrorComponent
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
/**
 *
 * @author dlolugu1271
 * @description This an app routing module class which describes how the
 * selfservice application does the navigations to their respective components.
 * 
 */
export class AppRoutingModule { }



// WEBPACK FOOTER //
// /home1/jenkins/jobs/SUPPORTCS_AJS_PROD/workspace/src/app/app-routing.module.ts